import React from 'react';
import {Link} from "react-router-dom";
import PropTypes from 'prop-types'

function DropdownOptionList(props) {

    const DropdownListOption = (link, title,firstlast, isLast, isFirst) => {

        const lastStyles = {
            borderBottomLeftRadius: '10px',
            borderBottomRightRadius: '10px'
        }
        
        const firstStyles = {
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px'
        }

        const stylesSwitcher = () => {
            if (firstlast){
                return {...firstStyles, ...lastStyles}
            }
            else if (isLast) {
                return lastStyles
            } else if (isFirst) {
                return firstStyles
            } else return {}
        }
        return (
            <Link key={title + link} to={link}>
                <div style={stylesSwitcher()} className="RouteOption_dropdown-list__option">
                    {title}
                </div>
            </Link>)
    }


    return (
        <div className={'RouteOption_dropdown-list'}>
            {props.routeList.map(
                (route, index) => {
                    return DropdownListOption(route.route, route.title,props.routeList.length === 1 , (index + 1) === props.routeList.length, index === 0)
                }
            )}
        </div>
    );
}

export default DropdownOptionList;

DropdownOptionList.propTypes = {
    routeList: PropTypes.arrayOf(PropTypes.shape({
        link: PropTypes.string,
        title: PropTypes.string,
    })).isRequired
}